import React, { useEffect, useState, useRef } from 'react';
import EfSpec from '@elem/ui/ef-spec';
import SignUp from './comps/SignUp';
import Banner from './comps/Banner';
import CardB1 from './comps/CardB1';
import FooterTC from './comps/FooterTC';
import NavA from './comps/NavA';
import PowerSolutions from './comps/PowerSolutions';
import SectionA from './comps/SectionA';
import SectionB from './comps/SectionB';
import SectionC from './comps/SectionC';
import SectionD from './comps/SectionD';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';

export default function Teaser() {
    const { locale } = getLocal();
    const [showNav, setShowNav] = useState(false);

    const allowLangs = ['us', 'ca'];
    let interObserver: IntersectionObserver | null;

    useEffect(() => {
        if (!allowLangs.includes(locale)) return;
        const apperCb: IntersectionObserverCallback = (params: IntersectionObserverEntry[]) => {
            const data = params[0];
            const calIconStatus = data.intersectionRatio <= 0;
            setShowNav(calIconStatus);
        };
        interObserver && interObserver.disconnect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        interObserver = new IntersectionObserver(apperCb, {
            threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1], // 设置多个阈值, 提高触发精度
        });

        const chooseBtn = document.querySelector('.power-solutions-box');
        if (chooseBtn) {
            interObserver.observe(chooseBtn as HTMLElement);
        }

        return () => {
            interObserver && interObserver.disconnect();
        };
    }, []);

    return (
        <div className={styles.teaser}>
            <Banner />
            <EfSpec />
            <PowerSolutions />
            {!!showNav && <NavA />}

            <SignUp />
            <SectionA />
            <SectionB />
            <SectionC />
            <SectionD />
            <CardB1 />
            <FooterTC />
        </div>
    );
}
